// extracted by mini-css-extract-plugin
export var hidden = "_4u-1";
export var leftPanel = "_4u-2";
export var readonlyInspector = "_4u-3";
export var rightPanel = "_4u-0";